export function AtveteliPrint({ id, job }) {
  return (
    <iframe id={"aprint"} src={"/json/delivery/print/atveteli/" + id + "?job=" + encodeURIComponent(job)} style={{ display: 'none' }} title="Átvételi nyomtatás" />
  );
}

export function printAtveteli(id, job) {
  window.open("/json/delivery/print/atveteli/" + id + "?job=" + encodeURIComponent(job), 'delivery_printer');
}